"use client";

import React from "react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const features = [{
  title: "Jornada Prateada",
  description: "Programa voltado para profissionais experientes que desejam reposicionar carreira, ampliar relevância e estruturar novos caminhos profissionais.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/Masterpro.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/Masterpro.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/Masterpro.png-wvc-sizes",
  buttonText: "INSCREVA-SE",
  link: "https://wa.me/5511966187866?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20a%20Jornada%20Prateada."
}, {
  title: "Liderança Prateada",
  description: "Desenvolvimento executivo para líderes e especialistas que desejam fortalecer influência, legado e posicionamento estratégico.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/Masterprocoroa.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/Masterprocoroa.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/Masterprocoroa.png-wvc-sizes",
  buttonText: "INSCREVA-SE",
  link: "https://wa.me/5511966187866?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20a%20Liderança%20Prateada."
}, {
  title: "Rede MasterPro+",
  description: "Ecossistema de networking executivo e conexões estratégicas entre profissionais seniores e lideranças corporativas.",
  icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/Masterproboll.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/Masterproboll.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/Masterproboll.png-wvc-sizes",
  buttonText: "CONECTE-SE",
  link: "https://wa.me/5511966187866?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20a%20Rede%20MasterPro+."
}];
export default function EngineeredForExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}